import {
  Box,
  Image,
  Stack,
  Text,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaTimes, FaHandshake } from "react-icons/fa";
import { BsCheckCircle } from "react-icons/bs";
import { trunc } from "../../utils";
import { photoBaseURL } from "../../service/api";
import { useGetState } from "../../context/useGetState";
import { LoadingMessage } from "../..";
import { follow, unFollow } from "../../pages/dashboard/discover/service";
import { useEffect, useState } from "react";
import { getUserProfile } from "../../context/getUserProfile";
import ShareToSocial from "../../pages/dashboard/discover/ShareToSocial";
import useSmallScreen from "../useSmallScreen";
import thelogo from "../../assets/thelogo.png";
import { useNavigate } from "react-router-dom";

function RandomUserCard({
  user,
  setSelectedUser,
  handleFollow,
  handleNotInterested,
  acctType,
  setBtnLoading,
  ...props
}) {
  const modeBg = useColorModeValue("#fff", "#030c1b");
  const modeBoxShadow = useColorModeValue("#80808024", "#030c1b");
  const { state } = useGetState();
  const [following, setFollowing] = useState(false);
  const [smallScreen] = useSmallScreen();

  const circleStyle = {
    bg: "#fff",
    w: "20px",
    h: "20px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: `2px 2px 14px 0px ${modeBoxShadow}`,
  };

  useEffect(() => {
    getUserProfile().then((res) => {
      // Extract the following_status field from the authuser profile response
      const followingStatus = res?.following_status;

      // Use the following_status field to set the 'following' state
      setFollowing(!!followingStatus);
    });
  }, [state?.userInfo, user]);

  const navigate = useNavigate();

  return (
    <Stack
      maxW={smallScreen ? "unset" : "150px"}
      minW={smallScreen ? "150px" : "150px"}
      flex={["1", "unset"]}
      borderRadius="15px"
      boxShadow={`2px 2px 14px 0px ${modeBoxShadow}`}
      p="5px"
      alignItems={"center"}
      bg={modeBg}
      cursor="pointer"
    >
      <Box
        position={"relative"}
        display="flex"
        justifyContent={"center"}
        alignItems="center"
        mb="10px"
      >
        <Image
          borderRadius={"15px"}
          w="180px"
          h="130px"
          objectFit={"cover"}
          src={user?.picture}
          alt="random user pic"
          fallbackSrc={thelogo}
          boxShadow={`2px 2px 14px 0px ${modeBoxShadow}`}
          onClick={() => setSelectedUser(user)}
        />
        <Stack
          direction={"row"}
          alignItems="center"
          position={"absolute"}
          bottom="-8px"
        >
          <Tooltip label="Not interested">
            <Box
              {...circleStyle}
              onClick={() => handleNotInterested(user)}
              cursor="pointer"
            >
              <FaTimes color="#170731" fontSize={".8em"} />
            </Box>
          </Tooltip>

          <Tooltip label={following ? "Unfollow" : "Follow"}>
            <Box
              {...circleStyle}
              onClick={() => handleFollow(user?.id, following)}
            >
              <FaHandshake color="#00B90D" />
            </Box>
          </Tooltip>
          <ShareToSocial sm id={user?.id} username={user?.username} />
        </Stack>
      </Box>

      <Stack
        direction={"row"}
        alignItems="center"
        spacing={"30px"}
        className="eachUsername"
        onClick={() => {
          navigate(`/view-profile/${user?.id}`);
        }}
      >
        <Tooltip label={`${user?.name}${" "}${user?.username}`}>
          <Text fontWeight={"bold"} fontSize=".9em">
            {trunc(`${user?.username}`, 13)}
          </Text>
        </Tooltip>

        {parseInt(user?.verification?.status) && (
          <BsCheckCircle color="#00B90D" />
        )}
      </Stack>

      <Text fontSize={".8em"} pb="10px">
        {user?.account_type}
      </Text>
    </Stack>
  );
}

export default RandomUserCard;
